import { DevAccountButton } from "../../authentication/DevAccounts";

export const LoginFooter = () => {
    return (
        <div className="text-[#999999] bg-white rounded-b-3xl flex items-center justify-center h-20">
            {/* <div className="text-[#999999] bg-background rounded-b-3xl flex items-center justify-center h-20"> */}
            {!process.env.REACT_APP_SYSTEM ? (
                <span>
                    <div className="px-1 text-center">Copyright © 2026 One Stop Center. All rights reserved.</div>
                </span>
            ) : (
                <span>
                    <div className="px-1 text-center">Copyright © 2026 One Stop Center. All rights reserved.</div>
                </span>
            )}
        </div>
    );
};
